import type { TourDefinition } from "@/types/tour";

export const marketInsightProcessingTour: TourDefinition = {
  id: "market-insight-processing-v1",
  context: "terminus-admin",
  version: 1,
  manual: true,
  steps: [
    {
      element: '[data-tour-id="mi-processing-overlay-minimize"]',
      popover: {
        title: "Minimize to background",
        description:
          "Click minimize to hide the overlay and keep working. The AI task continues in the background.",
      },
    },
    {
      element: '[data-notification-bell]',
      popover: {
        title: "Check notifications",
        description:
          "When processing finishes, a notification appears here. Its title gets a '— Complete' or '— Failed' suffix — even after page refresh.",
      },
    },
  ],
};
